import { z } from "zod";
import { TRawPublicKey } from "../../base";
import { TRawCompanyIntegrationBaseSettings } from "./integration";

export type IHybelIntegrationSettings = z.infer<typeof THybelIntegrationSettings>;
export const THybelIntegrationSettings = TRawCompanyIntegrationBaseSettings.extend({
  publicKey: TRawPublicKey.optional(),
});
